import t from"./StatusError.js";class r extends t{constructor(t){super(t,`Record for transaction ${t.transactionId.toString()} contained error status ${t.status.toString()}`),this.transactionRecord=t.transactionRecord}}export{r as default};
//# sourceMappingURL=RecordStatusError.js.map
